window.dn = window.dn || {};

(function (token, $, undefined)
{
    /**
     * The DOM identifier used for the Buy Tokens modal dialog, and prefix for related elements.
     */
    token.BuyTokensId = "dn-buy-tokens";

    /**
     * The DOM identifier used for the Subscribe modal dialog, and prefix for related elements.
     */
    token.SubscribeId = "dn-token-subscribe";

    /**
     * The DOM identifier used for the Tip Tokens modal dialog, and prefix for related elements.
     */
    token.TipTokensId = "dn-tip-tokens";

    /**
     * The current user's wallet. This gets set automatically if you call
     * token.GetWallet(), or anything else that calls that function (like ShowWalletBalance).
     */
    token.Wallet = 
    {
         Balance: 0,
         BalanceWithdrawable: 0
    };

    /**
     * Our supported withdrawal methods.
     */
     token.WalletConnectionType = 
     {
         Stripe: 1
     };

    /**
     * The DOM identifier used for the Withdraw Tokens modal dialog, and prefix for related elements.
     */
    token.WithdrawTokensId = "dn-withdraw-tokens";

    /**
     * Internal function called when something has changed on the "Buy Tokens" form and
     * we want to see whether or not we should enable the Buy button, among other things.
     */
    function checkEnableBuyButton()
    {
        if ($('#' + token.BuyTokensId + '-paymentsource').data('payment-source-key') && $('#' + token.BuyTokensId + '-amount').val())
        {
            // enable the buy tokens button
            $("#" + token.BuyTokensId + '-button').prop("disabled", false);
        }

        // Try to show the current cost, if known.
        var numTokens = parseInt($('#' + token.BuyTokensId + '-amount').val());
        if (numTokens > -1)
        {
            $('#' + token.BuyTokensId + '-button').text('Buy ' + numTokens + ' Token' + (numTokens == 1 ? '' : 's') + ' for $' + dn.DecimalToString(dn.constants.TokenPurchaseAmount * numTokens, 2));
        }

        // disable the button if < 1 or NaN
        $('#' + token.BuyTokensId + '-button').prop('disabled', (numTokens <= 0 || isNaN(numTokens)));
    }

    /**
     * Show the "Buy Tokens" modal popup.
     * 
     * @param {decimal} numTokens   - Number of tokens to buy. If not given, defaults to 1.
     * @param {func} onTokensBought - Callback that will be run when the token purchase has completed, passing the result from Stripe.
     * @param {func} onClose        - Callback that will be run if the modal is closed before purchasing.
     */
    token.Buy = function(numTokens, onTokensBought, onClose) {

        dn.agreement.Verify('Bounties', function() {

            var title = "Buy Tokens";

            if (!numTokens || numTokens < 0)
            {
                numTokens = 1;
            }

            $('#' + token.BuyTokensId).remove();  // remove if it already exists
            $("body").append($('<div class="modal" tabindex="-1" role="dialog" style="display: none" id="' + token.BuyTokensId + '">\
                <div class="modal-dialog" role="document">\
                    <div class="modal-content">\
                        <div class="modal-header">\
                            <h5 class="modal-title"><b>' + title + '</b></h5>\
                            <button type="button" class="close ' + token.BuyTokensId + '-close" data-dismiss="modal" aria-label="Close">\
                            <span aria-hidden="true">&times;</span>\
                            </button>\
                        </div>\
                        <div class="modal-body">\
                            <p>' + dn.constants.CommunityName + ' Tokens, called ' + dn.constants.TokenCurrencyCode + ' or ' + dn.constants.TokenCurrencySymbolHtml + ', \
                            can be used to post a bounty, allowing you to offer a financial incentive to receive more help, more quickly. Each \
                            token costs <b>' + dn.constants.TokenPurchaseCurrency + ' $' + dn.DecimalToString(dn.constants.TokenPurchaseAmount, 2) + '</b>. \
                            <a href="/help#tokens" target="' + dn.constants.LinkTargetNewWindow + '">Learn more about tokens.</a></p>\
                            <div class="alert alert-danger" style="display: none" id="' + token.BuyTokensId + '-error" role="alert"></div>\
                            <label for="' + token.BuyTokensId + '-amount" class="dn-form-label">Number of tokens</label>\
                            <div class="input-group mb-3">\
                                <div class="input-group-prepend">\
                                    <span class="input-group-text">' + dn.constants.TokenCurrencySymbolHtml + '</span>\
                                </div>\
                                <input type="number" min="1" max="' + dn.constants.TokenMaxPurchasePerRequest + '" id="' + token.BuyTokensId + '-amount" value="' + numTokens + '" class="dn-token-amount form-control col-3 col-sm-2" aria-label="Number of tokens to purchase" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"> \
                            </div>\
                            <label for="' + token.BuyTokensId + '-paymentsource" class="dn-form-label">Payment source</label>\
                            <div id="' + token.BuyTokensId + '-paymentsource" class="' + token.BuyTokensId + '-paymentsource dropdown dn-modal-dropdown"></div>\
                            <p id="closing-modal"></p>\
                        </div>\
                        <div class="modal-footer">\
                            <button type="button" class="btn btn-secondary ' + token.BuyTokensId + '-close" id="' + token.BuyTokensId + '-cancel" data-dismiss="modal">Cancel</button>\
                            <button type="button" class="btn btn-primary" id="' + token.BuyTokensId + '-button" disabled="disabled">Buy ' + numTokens + ' Token' + (numTokens == 1 ? '' : 's') + ' for $' + dn.DecimalToString(dn.constants.TokenPurchaseAmount, 2) + '</button>\
                        </div>\
                    </div>\
                </div>\
            </div>'));

            // stop any spinners before showing our new one
            dn.Spin(false);

            // remember the modals that were already open before us, so we can show them when done. 
            var openModals = $('.modal.show');
            openModals.modal('hide');

            var id = '#' + token.BuyTokensId;
            $(id).modal();

            // Get payment sources available for tokens
            dn.billing.CreatePaymentSourceDropdown({
                element:        $(id + '-paymentsource'), 
                showSpinner:    true, 
                onSuccess: function() {
                    checkEnableBuyButton();
                }, 
                onSourceSelected: function() {
                    checkEnableBuyButton();
                }, 
                onAddSource: function() {
                    checkEnableBuyButton();
                }, 
                onFailure: function(xhr, textStatus, errorThrown) {
                    // disable the buy tokens button
                    $(id + '-button').prop("disabled", true);

                    if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) {
                        // The initial request for the message details failed, tell the user
                        var error = dn.FormatApiError(xhr.responseJSON);
                        $(id + '-error').text('Problem retrieving your list of payment sources: ' + error + '.').show();
                    }
                }
            });

            // Close button clicked
            $('.' + token.BuyTokensId + '-close').click(function(event) {
                openModals.modal('show'); // re-show modals that were open when we first appeared
                if (onClose)
                {
                    onClose();
                }
            });

            $(id + '-amount').on('input', checkEnableBuyButton);

            // modal is being opened
            checkEnableBuyButton();

            dn.billing.LoadProcessor(function() {

                // the "Buy Tokens" button was clicked
                $(id + '-button').click(function () {
                    var numTokens = parseFloat($(id + '-amount').val()); // don't enforce fractional rules here, as it hides data loss

                    if (!numTokens || numTokens < 1 || numTokens > dn.constants.TokenMaxPurchasePerRequest)
                    {
                        $(id + '-error').html('You can buy up to ' + dn.constants.TokenMaxPurchasePerRequest + ' tokens.').show();
                        $(id + '-amount').addClass("is-invalid");
                    }
                    else if (numTokens != parseInt(numTokens))
                    {
                        $(id + '-error').text('Fractional tokens cannot be purchased at this time.').show();
                        $(id + '-amount').addClass("is-invalid");
                    }
                    else 
                    {
                        $(id + '-error').text('').hide(); // In case we showed an error at some point.
                        $(id + '-amount').removeClass("is-invalid");

                        var paymentSourceKey = $(id + '-paymentsource').data('payment-source-key');
                        var buyWhat = 'Buy ' + numTokens + ' Token' + (numTokens == 1 ? '' : 's');
                        var amount = numTokens * dn.constants.TokenPurchaseAmount;

                        if (paymentSourceKey === 'card')
                        {
                            // they want to pay with a new card, so we need to open Stripe Checkout,
                            // collect their new payment source info, and THEN call into our API to buy.
                            // Open Checkout for monthly subscription
                            dn.billing.Processor.open({
                                name: dn.constants.CommunityName,
                                email: dn.user.Email,
                                description: dn.constants.CommunityName + ' Token (' + dn.constants.TokenCurrencyCode + ')',
                                panelLabel: buyWhat + ' for {{amount}}',
                                allowRememberMe: false,
                                locale: "auto",
                                amount: amount * 100,
                                token: function (ev, args) {
                                    $('#change-error').hide();
                                    dn.Spin(true);
                                    $.postJSON("/api/v1/token/buy", { NumTokens: numTokens, PaymentSourceKey: ev.id })
                                    .done(function (tokens) {
                                        // Tokens have now been purchased!

                                        // Stop the progress spinner
                                        dn.Spin(false);

                                        // Close the Buy Tokens modal
                                        $(id).modal('hide');

                                        // If the thing calling token.Buy passed in an onTokensBought callback, run it
                                        if (onTokensBought)
                                        {
                                            onTokensBought(tokens);
                                        }
                                    })
                                    .fail(function (xhr, textStatus, errorThrown) {
                                        dn.Spin(false);
                                        if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) {
                                            var body = dn.FormatApiError(xhr.responseJSON);
                                            dn.ShowModal({ title: "Token Purchase Error", body: body, preserveOpenModals: true });
                                        }
                                    });
                                }
                            });
                        }
                        else
                        {
                            dn.ShowModal({
                                title: "Confirm Token Purchase",
                                body: 'Please confirm that you are paying ' + dn.constants.TokenPurchaseCurrency + ' <b>$' + dn.DecimalToString(numTokens * dn.constants.TokenPurchaseAmount, 2) + '</b> for <b>' + dn.constants.TokenCurrencySymbolHtml + dn.DecimalToString(numTokens, 2) + '</b> in ' + dn.constants.TokenCurrencyName + ' (' + dn.constants.TokenCurrencyCode + '), and that you understand token purchases are non-refundable.',
                                buttonText: buyWhat + ' for $' + dn.DecimalToString(amount, 2),
                                buttonClass: 'btn-success',
                                closeButtonText: 'Cancel',
                                preserveOpenModals: true,
                                onButtonClick: function (e, $modal) {
                                    $(e.target).attr('disabled', true);
                                    dn.Spin(true);
                                    $.postJSON("/api/v1/token/buy", { NumTokens: numTokens, PaymentSourceKey: paymentSourceKey })
                                    .done(function (tokens) {
                                        // Tokens have now been purchased!

                                        // Stop the progress spinner and close the confirmation dialog
                                        dn.Spin(false);
                                        $modal.modal('hide');

                                        // Close the Buy Tokens modal
                                        $(id).modal('hide');

                                        // If the thing calling token.Buy passed in an onTokensBought callback, run it
                                        if (onTokensBought)
                                        {
                                            onTokensBought(tokens);
                                        }
                                    })
                                    .fail(function (xhr, textStatus, errorThrown) {

                                        // Close the confirmation modal
                                        dn.Spin(false);
                                        $modal.modal('hide');

                                        // Show the error modal
                                        if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) {
                                            var body = dn.FormatApiError(xhr.responseJSON);
                                            dn.ShowModal({ title: "Token Purchase Error", body: body, preserveOpenModals: true });
                                        }
                                    });
                                }
                            });
                        }
                    }
                });

            }, function(xhr, textStatus, errorThrown) {
                // disable the buy tokens button
                $(id + '-button').prop("disabled", true);

                if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) {
                    // The initial request for the message details failed, tell the user
                    var error = dn.FormatApiError(xhr.responseJSON);
                    $(id + '-error').html('There was a problem loading our payment processor:<br/><br/>' + error).show();
                }            
            });

            $(id).modal('show');

            // select the text of the input for easier changes by the user
            $(id + '-amount').focus
            (
                function() 
                { 
                    window.setTimeout
                    (
                        function()
                        { 
                            $(id + '-amount').select(); 
                        },
                        0
                    );
                }
            )
            .focus();
        });
    };

    /**
     * Internal function called when something has changed on the "Tip" form and
     * we want to see whether or not we should enable the Tip button, among other things.
     */
    function checkEnableTipButton()
    {
        var id = '#' + token.TipTokensId;

        if ($(id + '-comments').val() && $(id + '-amount').val())
        {
            // enable the tip button
            $(id + '-button').prop("disabled", false);
        }

        // Update the tip button to reflect the # of tokens
        var numTokens = parseInt($(id + '-amount').val());
        if (numTokens > -1)
        {
            $(id + '-button').html('Send&nbsp;&nbsp;' + dn.constants.TokenCurrencySymbolHtml + numTokens);
        }

        if (numTokens > dn.token.Wallet.Balance && (!$(id + '-promo').length || !$(id + '-promo').is(":checked")))
        {
            // they don't have enough tokens, and they aren't a staff member with the promo checkbox tapped, so show the Buy More button
            $('.' + dn.token.TipTokensId + '-buy-tokens').html('Buy&nbsp;&nbsp;' + dn.constants.TokenCurrencySymbolHtml + Math.ceil(numTokens - dn.token.Wallet.Balance));
            $('.dn-need-tokens').show();

            // and disable the Tip button
            $(id + '-button').prop("disabled", true);
        }
        else
        {
            // they have enough tokens, hide the Buy More button
            $('.dn-need-tokens').hide();

            // and enable the Tip button, as long as they're trying to add a +1 tip or more
            $(id + '-button').prop('disabled', (numTokens <= 0 || isNaN(numTokens)));
        }
    }

    /**
     * Show the "Tip" modal popup.
     * 
     * @param {data} user           - Info about the user that they want to tip, e.g. user.UserKey, user.FirstName, user.LastName.
     * @param {bool} showPromo      - If true, show the options for sending these as promotional tokens (staff only). Enforced server-side.
     * @param {func} onTip          - Callback that will be run when the token tip has completed, passing the result from Stripe.
     * @param {func} onClose        - Callback that will be run if the modal is closed before purchasing.
     */
    token.Tip = function(user, showPromo, onTip, onClose) {

        dn.agreement.Verify('Bounties', function() {

            var title = "Tip " + user.FirstName + " " + user.LastName;

            var numTokens = 1;

            $('#' + token.TipTokensId).remove();  // remove if it already exists
            $("body").append($('<div class="modal" tabindex="-1" role="dialog" style="display: none" id="' + token.TipTokensId + '">\
                <div class="modal-dialog" role="document">\
                    <div class="modal-content">\
                        <div class="modal-header">\
                            <h5 class="modal-title"><b>' + title + '</b></h5>\
                            <button type="button" class="close ' + token.TipTokensId + '-close" data-dismiss="modal" aria-label="Close">\
                            <span aria-hidden="true">&times;</span>\
                            </button>\
                        </div>\
                        <div class="modal-body">\
                            <p>' + dn.constants.CommunityName + ' Tokens, called ' + dn.constants.TokenCurrencyCode + ' and represented by the ' + dn.constants.TokenCurrencySymbolHtml + ' symbol, \
                            can be used to tip a member, perhaps for helping you with a problem, or as a gift. <a href="/help#tokens" target="' + dn.constants.LinkTargetNewWindow + '">Learn more about tokens.</a></p>\
                            <div class="alert alert-danger" style="display: none" id="' + token.TipTokensId + '-error" role="alert"></div>\
                            <label for="' + token.TipTokensId + '-amount" class="dn-form-label">Number of tokens</label>\
                            <div class="input-group mb-3">\
                                <div class="input-group-prepend">\
                                    <span class="input-group-text">' + dn.constants.TokenCurrencySymbolHtml + '</span>\
                                </div>\
                                <input type="number" min="1" max="' + dn.constants.TokenMaxPurchasePerRequest + '" id="' + token.TipTokensId + '-amount" value="' + numTokens + '" class="dn-token-amount form-control col-3 col-sm-2" aria-label="Number of tokens to purchase" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"> \
                            </div>\
                            <label for="' + token.TipTokensId + '-comments" class="dn-form-label">Comments</label>\
                            <textarea class="form-control" id="' + token.TipTokensId + '-comments" class="' + token.TipTokensId + '-comments" rows="3" placeholder="Let ' + user.FirstName + ' know why you are sending them tokens."></textarea>' +
                            (showPromo ? '<label for="' + token.TipTokensId + '-comments" class="dn-form-label mt-3">Options</label><div class="custom-control custom-checkbox"><input type="checkbox" class="custom-control-input" id="' + dn.token.TipTokensId + '-promo" value="1"><label class="custom-control-label" for="' + dn.token.TipTokensId + '-promo">Send Promo Tokens (No Withdrawal)</label></div>' : '') + 
                            '<p class="mt-2 mb-0 dn-need-tokens" style="display: none"><button type="button" class="btn btn-success btn-sm ' + dn.token.TipTokensId + '-buy-tokens py-0">Buy Tokens</button> to tip this amount.</p>\
                            <p id="closing-modal"></p>\
                        </div>\
                        <div class="modal-footer">\
                            <div class="flex-grow-1 text-left"><span class="d-none d-sm-inline">Wallet </span>Balance <span class="dn-wallet-balance ml-0 font-weight-bold clickable">' + dn.constants.TokenCurrencySymbolHtml + '0</span></div>\
                            <button type="button" class="btn btn-primary" id="' + token.TipTokensId + '-button" disabled="disabled">Send&nbsp;&nbsp;' + dn.constants.TokenCurrencySymbolHtml + numTokens + '</button>\
                        </div>\
                    </div>\
                </div>\
            </div>'));

            // stop any spinners before showing our new one
            dn.Spin(false);

            // remember the modals that were already open before us, so we can show them when done. 
            var openModals = $('.modal.show');
            openModals.modal('hide');

            var id = '#' + token.TipTokensId;
            $(id).modal();

            // If they click their current balance, reload their balance, and then set the bounty value to that amount.
            $('.dn-wallet-balance').click(function(e) {
                dn.token.UpdateWalletBalance($('.dn-wallet-balance'), null, $(id + '-error'), function(e) {
                    $(id + '-amount').val(dn.token.Wallet.Balance).change();
                    checkEnableTipButton();
                });
            });

            // Tip button clicked
            $(id + '-button').click(function(event) {

                var numTokens = parseFloat($(id + '-amount').val());
                var comments = $(id + '-comments').val();
                var isPromo = $(id + '-promo').is(':checked');

                if (!numTokens || numTokens < 1 || numTokens > dn.constants.TokenMaxCashOutPerRequest)
                {
                    $(id + '-error').html('You can tip up to ' + dn.constants.TokenMaxCashOutPerRequest + ' tokens max at a time.').show();
                    $(id + '-amount').addClass("is-invalid");
                }
                else if (!isPromo && numTokens > dn.token.Wallet.Balance)
                {
                    $(id + '-error').html('You can tip up to your balance of ' + dn.token.Wallet.Balance + ' tokens.').show();
                    $(id + '-amount').addClass("is-invalid");
                }
                else if (numTokens != parseInt(numTokens))
                {
                    $(id + '-error').text('Fractional tokens cannot be tipped at this time.').show();
                    $(id + '-amount').addClass("is-invalid");
                }
                else 
                {
                    $(id + '-error').text('').hide(); // In case we showed an error at some point.
                    $(id + '-amount').removeClass("is-invalid");

                    var formattedTokens = dn.DecimalToString(numTokens, 2);

                    dn.ShowModal({
                        title: "Confirm " + (isPromo ? " Promo Tokens" : "Tip"),
                        body: 'Please confirm that you are ' + (isPromo ? 'sending' : 'tipping') + ' <b>' + dn.constants.TokenCurrencySymbolHtml + formattedTokens + '</b> to <b>' + user.FirstName + ' ' + user.LastName + '</b>. Once confirmed, we will notify ' + user.FirstName + ' about the ' + (isPromo ? 'tokens' : 'tip') + (comments ? ':<div class="alert alert-secondary my-2 px-2" role="alert">' + comments + '</div>' : '.<br><br>') + 'Tokens are instantly transferred and non-refundable.',
                        buttonText: 'Confirm ' + (isPromo ? 'Send' : 'Tip') + ' of&nbsp;&nbsp;' + dn.constants.TokenCurrencySymbolHtml + formattedTokens,
                        buttonClass: 'btn-success',
                        closeButtonText: 'Cancel',
                        preserveOpenModals: true,
                        onButtonClick: function (e, $modal) {

                            $(e.target).attr('disabled', true);
                            dn.Spin(true);

                            $.postJSON("/api/v1/token/" + (isPromo ? "promo" : "tip"), {
                                NumTokens: numTokens,
                                ToUserKey: user.UserKey,
                                Comments: comments
                            })
                            .done(function (response) {

                                // Tip sent
                                // Stop the progress spinner
                                dn.Spin(false);
                                $modal.modal('hide');

                                // Close the Tip modal
                                $(id).modal('hide');

                                // update the wallet balance
                                token.UpdateWalletBalance($('.dn-wallet-balance'), $('.dn-wallet-balance-withdrawable'), $(id + '-error'), checkEnableTipButton);

                                // Show a Thank-You dialog
                                dn.ShowModal({
                                    title: 'Tip Sent',
                                    body: 'Your tip of <b>' + dn.constants.TokenCurrencySymbolHtml + numTokens + '</b>' + (isPromo ? ' (promo tokens) ' : ' ') + 'has been sent to <b>' + user.FirstName + ' ' + user.LastName + '</b>. They will receive an email letting them know' + ((comments) ? ', as well as your comments.' : '.'),
                                });

                                // If the thing calling token.Tip passed in an onTip callback, run it
                                if (onTip)
                                {
                                    onTip(response);
                                }
                            })
                            .fail(function (xhr, textStatus, errorThrown) {

                                // Stop the progress spinner
                                dn.Spin(false);
                                $modal.modal('hide');

                                // Check our status
                                checkEnableTipButton();

                                if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) {
                                    // Show the error modal
                                    var body = dn.FormatApiError(xhr.responseJSON);
                                    dn.ShowModal({ title: "Error", body: body, preserveOpenModals: true });
                                }
                            });
                        }
                    });
                }
            });

            // Close button clicked
            $('.' + token.TipTokensId + '-close').click(function(event) {
                if (onClose)
                {
                    onClose();
                }
            });

            // Buy Tokens button clicked
            $('.' + dn.token.TipTokensId + '-buy-tokens').unbind('click').click(function(event) {

                var numTokens = parseInt($(id + '-amount').val());

                dn.token.Buy(
                    (numTokens - dn.token.Wallet.Balance), 
                    function(transaction) {
                        dn.token.UpdateWalletBalance($('.dn-wallet-balance'), $('.dn-wallet-balance-withdrawable'), $(id + '-error'), checkEnableTipButton);
                        $(id).modal('show'); // our Tip dialog might be hidden
                    }, 
                    function() {
                        // closed without buying tokens, just update the balance anyway
                        dn.token.UpdateWalletBalance($('.dn-wallet-balance'), $('.dn-wallet-balance-withdrawable'), $(id + '-error'), checkEnableTipButton);
                    }
                );
            });

            $(id + '-amount').on('input', checkEnableTipButton);
            $(id + '-promo').change(checkEnableTipButton);

            token.UpdateWalletBalance($('.dn-wallet-balance'), $('.dn-wallet-balance-withdrawable'), $(id + '-error'), checkEnableTipButton);

            $(id).modal('show');

            // select the text of the input for easier changes by the user
            $(id + '-amount').focus
            (
                function() 
                {
                    window.setTimeout
                    (
                        function()
                        { 
                            $(id + '-amount').select(); 
                        },
                        0
                    );
                }
            )
            .focus();
        });
    };

    /**
     * Internal function called when something has changed on the "Withdraw Tokens" form and
     * we want to see whether or not we should enable the Withdraw button, among other things.
     */
    function checkEnableWithdrawButton(event)
    {
        if ($('#' + token.WithdrawTokensId + '-paymentsource').data('payment-source-key') && $('#' + token.WithdrawTokensId + '-amount').val())
        {
            // enable the withdraw tokens button
            $("#" + token.WithdrawTokensId + '-button').prop("disabled", false);
        }

        // Try to show the current cost, if known.
        var numTokens = parseInt($('#' + token.WithdrawTokensId + '-amount').val());
        if (numTokens > -1)
        {
            $('#' + token.WithdrawTokensId + '-button').text('Withdraw ' + numTokens + ' Token' + (numTokens == 1 ? '' : 's') + ' for $' + (dn.constants.TokenCashOutAmount * numTokens).toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2}));
        }

        // disable the button if < 1 or NaN, or withdrawal method not set
        $('#' + token.WithdrawTokensId + '-button').prop('disabled', (numTokens <= 0 || isNaN(numTokens) || !$('#' + token.WithdrawTokensId).data('wallet-connection-id')));
    }

    /**
     * Countries that are allowed to use Stripe Connect "Express." Don't forget that these need 
     * to be activated for connect and transfers: https://dashboard.stripe.com/settings/connect/express
     * More info: https://stripe.com/docs/connect/cross-border-payouts
     */
    token.ExpressCountries = ["AR", "AT", "AU", "BE", "BG", "BO", "CA", "CH", "CL", "CO", "CR", "CY", "CZ", "DE", "DK", "DO", "EE", "EG", "ES", "FI", "FR", "GB", "GR", "HK", "HR", "HU", "ID", "IE", "IL", "IN", "IS", "IT", "LI", "LT", "LU", "LV", "MT", "MX", "NL", "NO", "NZ", "PE", "PL", "PT", "PY", "RO", "SE", "SG", "SI", "SK", "TH", "TT", "US", "UY"];

    /**
     * Show the "Withdraw Tokens" modal popup.
     * 
     * @param {decimal} numTokens   - Number of tokens to withdraw. If not given, defaults to their current wallet balance.
     * @param {string} connectionId - The Wallet Connection id to use for this withdrawal. TODO: Eventually this should be determined within this popup, not passed in!
     * @param {func} onWithdrawn    - Callback that will be run when the token withdrawal has completed, passing the result from Stripe.
     * @param {func} onClose        - Callback that will be run if the modal is closed before purchasing.
     */
    token.Withdraw = function(numTokens, connectionId, onWithdrawn, onClose) 
    {
        dn.agreement.Verify('Bounties', function() 
        {
            var title = "Withdraw Tokens";
            var stripeConnectExplanation = '';
            var stripeConnectButton = '';
            var stripeConnectDestination = '';
            var withdrawalDestination = '';

            if ($.inArray(dn.user.BusinessCountry, dn.token.ExpressCountries) > -1)
            {
                stripeConnectExplanation = 'We use Stripe Connect to securely transfer money to your bank account, via ACH or debit card withdrawals. You should only need to setup Stripe Connect one time. By continuing, you agree to the ' + (dn.user.BusinessCountry === 'US' ? '<a href="https://stripe.com/connect-account/legal" target="_blank">Stripe Connect Agreement</a>.' : '<a href="https://stripe.com/connect-account/legal/recipient" target="_blank">Stripe Recipient Agreement</a>.');
                stripeConnectButton = '<p><img class="clickable" id="dn-wallet-connect-stripe" src="' + dn.constants.UrlWebAssets + 'img/payments/stripeconnect-light-on-light.png" width="190" height="33"></p>';
                stripeConnectDestination = '<i class="fas fa-university fa-lg text-success mr-1"></i> Send to Bank Account (via <i class="fab fa-stripe fa-2x align-middle" style="position: relative; top: 7px;"></i>)';
                withdrawalDestination = 'your bank account (via Stripe)';
            }
            else
            {
                stripeConnectExplanation = 'We do not currently support withdrawing tokens into a bank account in your country, but we will continue to look for new ways to withdraw funds in your country.';
            }

            if (!numTokens || numTokens < 0)
            {
                numTokens = token.Wallet.BalanceWithdrawable;
            }

            var maxWithdrawal = (dn.token.Wallet.BalanceWithdrawable < dn.constants.TokenMaxCashOutPerRequest) ? dn.token.Wallet.BalanceWithdrawable : dn.constants.TokenMaxCashOutPerRequest;

            $('#' + token.WithdrawTokensId).remove();  // remove if it already exists
            $("body").append($('<div class="modal" tabindex="-1" role="dialog" style="display: none" id="' + token.WithdrawTokensId + '">\
                <div class="modal-dialog" role="document">\
                    <div class="modal-content">\
                        <div class="modal-header">\
                            <h5 class="modal-title"><b>' + title + '</b></h5>\
                            <button type="button" class="close ' + token.WithdrawTokensId + '-close" data-dismiss="modal" aria-label="Close">\
                            <span aria-hidden="true">&times;</span>\
                            </button>\
                        </div>\
                        <div class="modal-body">\
                            <p>Withdraw tokens to your bank account at a conversion rate of ' + dn.constants.TokenPurchaseCurrency + ' <b>$' + dn.DecimalToString(dn.constants.TokenCashOutAmount, 2) + '</b> per token.</p>\
                            <div class="alert alert-danger" style="display: none" id="' + token.WithdrawTokensId + '-error" role="alert"></div>\
                            <label for="' + token.WithdrawTokensId + '-amount" class="dn-form-label">Number of tokens</label>\
                            <div class="input-group mb-3">\
                                <div class="input-group-prepend">\
                                    <span class="input-group-text">' + dn.constants.TokenCurrencySymbolHtml + '</span>\
                                </div>\
                                <input type="number" min="1" max="' + maxWithdrawal + '" id="' + token.WithdrawTokensId + '-amount" value="' + numTokens + '" class="dn-token-amount form-control col-3 col-sm-2" aria-label="Number of tokens to purchase" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"> \
                            </div>\
                            <label for="' + token.WithdrawTokensId + '-destination" class="dn-form-label">Withdrawal method</label>' +
                            (connectionId ? '<p>' + stripeConnectDestination + '</p>' : '<div><p>' + stripeConnectExplanation + '</p>' + stripeConnectButton + '</div>') +
                            '<p id="closing-modal"></p>\
                        </div>\
                        <div class="modal-footer">\
                            <button type="button" class="btn btn-secondary ' + token.WithdrawTokensId + '-close" id="' + token.WithdrawTokensId + '-cancel" data-dismiss="modal">Cancel</button>\
                            <button type="button" class="btn btn-primary" id="' + token.WithdrawTokensId + '-button" disabled="disabled">Withdraw ' + numTokens + ' Token' + (numTokens == 1 ? '' : 's') + ' for $' + dn.DecimalToString(dn.constants.TokenPurchaseAmount, 2) + '</button>\
                        </div>\
                    </div>\
                </div>\
            </div>'));

            // stop any spinners before showing our new one
            dn.Spin(false);

            // remember the modals that were already open before us, so we can show them when done. 
            var openModals = $('.modal.show');
            openModals.modal('hide');

            var id = '#' + token.WithdrawTokensId;
            $(id).modal();

            $(id).data('wallet-connection-id', connectionId);

            // Close button clicked
            $('.' + token.WithdrawTokensId + '-close').click(function(event) {
                openModals.modal('show'); // re-show modals that were open when we first appeared
                if (onClose)
                {
                    onClose();
                }
            });

            // Stripe Connect button clicked
            $('#dn-wallet-connect-stripe').click(function(event) 
            {
                $(id + '-error').hide();
                dn.Spin(true);

                $.postJSON("/api/v1/wallet/connection", 
                {
                    Type: 1 // Stripe
                })
                .done(function (response) 
                {
                    if (response.RedirectUrl)
                    {
                        // Redirect url provided to complete onboarding
                        $(id).modal('hide');
                        window.top.location.href = response.RedirectUrl;
                    }
                    else
                    {
                        // No redirect provided, handle the error
                        $(id + '-error').html((response.Error ? response.Error : 'An error occurred trying to setup your account with Stripe.') + ' If the problem continues, please <a href=\"/contact\">contact us</a>.').show();
                    }
                })
                .fail(function (xhr, textStatus, errorThrown) 
                {
                    if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                    {
                        // Show the error modal
                        var error = dn.FormatApiError(xhr.responseJSON);
                        $(id + '-error').html((error ? error : 'An error occurred trying to setup your account with Stripe.') + ' If the problem continues, please <a href=\"/contact\">contact us</a>.').show();
                    }
                })
                .always(function (xhr, textStatus, errorThrown)
                {
                    // Stop the progress spinner
                    dn.Spin(false);
                });
            });

            $(id + '-amount').on('input', checkEnableWithdrawButton);

            // modal is being opened
            checkEnableWithdrawButton();

            $(id + '-button').unbind("click").click(function () {

                var id = '#' + token.WithdrawTokensId;
                var numTokens = parseFloat($(id + '-amount').val()); // don't enforce fractional rules here, as it hides data loss

                if (!numTokens || numTokens < 1 || numTokens > dn.constants.TokenMaxCashOutPerRequest)
                {
                    $(id + '-error').html('You can withdraw up to ' + dn.constants.TokenMaxCashOutPerRequest + ' tokens at a time.').show();
                    $(id + '-amount').addClass("is-invalid");
                }
                else if (numTokens > dn.token.Wallet.BalanceWithdrawable)
                {
                    if (dn.token.Wallet.Balance !== dn.token.Wallet.BalanceWithdrawable)
                    {
                        // probably need to explain why they can't withdraw all tokens
                        $(id + '-error').html('You can withdraw up to ' + dn.token.Wallet.BalanceWithdrawable + ' tokens. The remainder of your balance consists of <a href="/help#promo-tokens">promotional tokens</a>, which can be used on ' + dn.constants.CommunityName + ', but not withdrawn.').show();
                    }
                    else
                    {
                        $(id + '-error').html('You can withdraw up to ' + dn.token.Wallet.Balance + ' tokens.').show();
                    }
                    $(id + '-amount').addClass("is-invalid");
                }
                else if (numTokens != parseInt(numTokens))
                {
                    $(id + '-error').text('Fractional tokens cannot be withdrawn at this time.').show();
                    $(id + '-amount').addClass("is-invalid");
                }
                else 
                {
                    $(id + '-error').text('').hide(); // In case we showed an error at some point.
                    $(id + '-amount').removeClass("is-invalid");

                    var destinationKey = $(id + '-destination').data('destination');
                    var withdrawWhat = 'Withdraw ' + numTokens + ' Token' + (numTokens == 1 ? '' : 's');
                    var amount = numTokens * dn.constants.TokenCashOutAmount;

                    dn.ShowModal({
                        title: "Confirm Token Withdrawal",
                        body: 'Please confirm that you are withdrawing <b>' + dn.DecimalToString(numTokens, 2) + '</b> ' + dn.constants.CommunityName + ' Tokens worth ' + dn.constants.TokenPurchaseCurrency + ' <b>$' + dn.DecimalToString(numTokens * dn.constants.TokenCashOutAmount, 2) + '</b> to ' + withdrawalDestination + '. It may take 2-3 business days for the funds to appear.',
                        buttonText: withdrawWhat + ' for $' + dn.DecimalToString(amount, 2),
                        buttonClass: 'btn-success',
                        closeButtonText: 'Cancel',
                        preserveOpenModals: true,
                        onButtonClick: function (e, $modal) {
                            $(e.target).attr('disabled', true);
                            dn.Spin(true);
                            $.postJSON("/api/v1/token/sell", { NumTokens: numTokens, WithdrawalMethod: token.WalletConnectionType.Stripe, WithdrawalDestinationId: connectionId })
                            .done(function (response) {

                                // Tokens have now been queued for withdrawal!
                                // Stop the progress spinner and close the confirmation dialog
                                dn.Spin(false);
                                $modal.modal('hide');

                                // Close the Withdraw Tokens modal
                                $(id).modal('hide');

                                dn.ShowNotification({title: 'Success!', body: 'Your withdrawal of ' + dn.constants.TokenCurrencySymbolHtml + numTokens + ' has been initiated. Check your email for more details.', className: 'toast-success'});

                                // If the thing calling token.Withdraw passed in an onWithdrawn callback, run it
                                if (onWithdrawn)
                                {
                                    onWithdrawn(response);
                                }
                                else
                                {
                                    // Update the wallet ballance
                                    dn.token.UpdateWalletBalance($('.dn-wallet-balance'), $('.dn-wallet-balance-withdrawable'))
                                }
                            })
                            .fail(function (xhr, textStatus, errorThrown) {

                                // Close the confirmation modal
                                dn.Spin(false);
                                $modal.modal('hide');

                                if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) {
                                    // Show the error modal
                                    var body = dn.FormatApiError(xhr.responseJSON);
                                    dn.ShowModal({ title: "Token Withdrawal Error", body: body, preserveOpenModals: true });
                                }
                            });
                        }
                    });
                }
            });

            $(id).modal('show');

            // select the text of the input for easier changes by the user
            $(id + '-amount').focus
            (
                function() 
                {
                    window.setTimeout
                    (
                        function()
                        {
                            $(id + '-amount').select();
                        },
                        0
                    );
                }
            )
            .focus();
        });
    };

    /**
     * Internal function called when some element of the Subscribe form changes, 
     * such as buying more tokens, or the person's wallet balance possibly updated, 
     * etc. Will enable/disable the "Buy X Months" button, and show/hide the 
     * "Buy DNT" button as needed.
     * 
     * @param {event} event          - If this is being called as a result of an event, like a click, pass it here.
     * @param {bool} retainSelection - If true, don't try to select a new amount. This is useful to prevent infinite click loops.
     */
    function updateSubscribeInfo(event)
    {
        var id = '#' + token.SubscribeId;

        var months = parseInt($(id).data('subscription-months')) || 12;
        var planId = $(id).data('plan-id') || dn.constants.SubscriptionPlanDefaultPaid;
        var cost = parseFloat($(this).data('subscription-cost')) || 15;

        if (event)
        {
            // grab new values from click event
            months = $(event.target).data('months');
            cost = $(event.target).data('cost');
            $(id).data('subscription-months', months);
            $(id).data('plan-id', planId);
            $(id).data('subscription-cost', cost);
        }

        $(id + '-length-button').html(months + ' Month' + (months === 1 ? '' : 's'));
        $(id + '-button').html('Subscribe ' + months + ' Month' + (months === 1 ? '' : 's') + ' for ' + dn.constants.TokenCurrencySymbolHtml + cost);

        if (cost > dn.token.Wallet.Balance)
        {
            // they don't have enough tokens, show the Buy More button
            $('.' + dn.token.SubscribeId + '-buy-tokens').html('Buy&nbsp;&nbsp;' + dn.constants.TokenCurrencySymbolHtml + Math.ceil(cost - dn.token.Wallet.Balance));
            $('.dn-need-tokens').show();

            // and disable the Subscribe button
            $(id + '-button').prop("disabled", true);
        }
        else
        {
            // they have enough tokens, hide the Buy More button
            $('.dn-need-tokens').hide();

            // and enable the Add Bounty button, as long as they're trying to add a +1 bounty or more
            $(id + '-button').prop("disabled", false);
        }

        // If this is being called NOT as part of a click event, go ahead and try to click a new selection
        if (!event)
        {
            // choose the highest amount of subscription they can afford
            $($(id + '-length-choices > button').get().reverse()).each(function(index, element) {
                if ($(element).data('cost') <= dn.token.Wallet.Balance)
                {
                    // they can afford this option, select it and exit
                    $(element).click();
                    return false;
                }
            });
        }
    }

    /**
     * Show the "Subscribe" modal popup.
     * 
     * @param {func}    onSubscribe     - Callback that will be run when the "Subscribe" button is clicked.
     * @param {func}    onClose         - Callback that will be run when the modal is closed.
     */
    token.Subscribe = function(onSubscribe, onClose) {

        dn.agreement.Verify('Bounties', function() {

            var title = 'Subscribe';
            var label = 'Subscription length';
            var opening = '<p>Tokens can be used to subscribe to ' + dn.constants.CommunityName + ', or extend your existing \
                subscription, for up to 12 months.';

            $('#' + token.SubscribeId).remove();  // remove if it already exists
            $("body").append($('<div class="modal" tabindex="-1" role="dialog" style="display: none" id="' + token.SubscribeId + '" data-subscription-months="12" data-plan-id="' + dn.constants.SubscriptionPlanDefaultPaid + '">\
                <div class="modal-dialog" role="document">\
                    <div class="modal-content">\
                        <div class="modal-header">\
                            <h5 class="modal-title"><b>' + title + '</b></h5>\
                            <button type="button" class="close ' + token.SubscribeId + '-close" data-dismiss="modal" aria-label="Close">\
                            <span aria-hidden="true">&times;</span>\
                            </button>\
                        </div>\
                        <div class="modal-body">\
                            ' + opening + '\
                            <div class="alert alert-danger" style="display: none" id="' + token.SubscribeId + '-error" role="alert"></div>' +
                            /*
                            <label for="' + token.SubscribeId + '-length" class="dn-form-label">' + label + '</label>\
                            <div id="' + token.SubscribeId + '-length" class="' + token.SubscribeId + '-length dropdown dn-modal-dropdown">\
                                <button id="' + token.SubscribeId + '-length-button" class="btn btn-lg dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Choose Length</button>\
                                <div class="dropdown-menu position-absolute" id="' + token.SubscribeId + '-length-choices" aria-labelledby="' + token.SubscribeId + '-length"></div>\
                            </div>\
                            */
                            '<p class="mt-2 mb-0 dn-need-tokens" style="display: none"><button type="button" class="btn btn-success btn-sm ' + dn.token.SubscribeId + '-buy-tokens py-0">Buy Tokens</button> to subscribe for this length.</p>\
                            <p id="closing-modal"></p>\
                        </div>\
                        <div class="modal-footer d-flex">\
                            <div class="flex-grow-1 text-left"><span class="d-none d-sm-inline">Wallet </span>Balance <span class="dn-wallet-balance ml-0 font-weight-bold">' + dn.constants.TokenCurrencySymbolHtml + '0</span></div>\
                            <button type="button" class="btn btn-primary dnt-in-sentence" disabled id="' + token.SubscribeId + '-button">' + title + '</button>\
                        </div>\
                    </div>\
                </div>\
            </div>'));

            // stop any spinners and close any open modals before showing our new one
            dn.Spin(false);

            var id = '#' + token.SubscribeId;
            $(id).modal();

            /*var annualCutoff = 10;

            for (var i = 1; i < 13; i++)
            {
                var cost = (i * dn.constants.BillingPriceMonthlyTokens);

                if (i > annualCutoff)
                {
                    if (i == 12)
                    {
                        // Annual (12 months) has a special price, and is separated by a divider.
                        cost = dn.constants.BillingPriceAnnualTokens;
                        $(id + '-length-choices').append('<div class="dropdown-divider"></div>');
                    }
                    else
                    {
                        // 11th month is skipped because it's the same price as 12
                        // For founders, the 10th and 11th month are skipped for this reason.
                        continue;
                    }
                }

                var choice = $('<button class="dropdown-item" data-months="' + i + '" data-cost="' + cost + '">' + i + ' Month' + (i === 1 ? '' : 's') + ' <span class="float-right ml-3 text-muted">' + dn.constants.TokenCurrencySymbolHtml + cost + '</span></button>');
                choice.click(function(event) {
                    updateSubscribeInfo(event);
                });
                $(id + '-length-choices').append(choice);
            }
            */

            // Subscribe button clicked
            $(id + '-button').click(function(event) {
                var numMonths = parseInt($(id).data('subscription-months'));
                var planId = $(id).data('plan-id');

                $(event.target).attr('disabled', true);
                dn.Spin(true);

                $.postJSON("/api/v1/token/subscribe/" + numMonths + "/" + planId)
                .done(function (response) {

                    // Subscription bought/extended
                    // Stop the progress spinner
                    dn.Spin(false);

                    // Close the Subscribe modal
                    $(id).modal('hide');

                    token.UpdateWalletBalance($('.dn-wallet-balance'), $('.dn-wallet-balance-withdrawable'), $(id + '-error'), updateSubscribeInfo);

                    // Show a Thank-You dialog
                    dn.ShowModal({
                        title: 'Subscription ' + response.Action.charAt(0).toUpperCase() + response.Action.slice(1),
                        body: response.Action === 'created'
                            ? ('Your subscription has been created and paid through <b>' + moment(response.DatePaidThrough, 'YYYY-MM-DDTHH:mm:ssZZ').format("MMMM D, YYYY") + "</b>.")
                            : ('Your subscription has been extended until <b>' + moment(response.DatePaidThrough, 'YYYY-MM-DDTHH:mm:ssZZ').format("MMMM D, YYYY") + "</b>."),
                        buttonText: 'View Subscription',
                        onButtonClick: function() { window.top.location.href = "/billing"; }
                    });

                    // If the thing calling token.Subscribe passed in an onSubscribe callback, run it
                    if (onSubscribe)
                    {
                        onSubscribe(response);
                    }
                })
                .fail(function (xhr, textStatus, errorThrown) {

                    // Stop the progress spinner
                    dn.Spin(false);

                    // Check our status
                    updateSubscribeInfo();

                    if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) {
                        // Show the error modal
                        var body = dn.FormatApiError(xhr.responseJSON);
                        dn.ShowModal({ title: "Subscription Error", body: body, preserveOpenModals: true });
                    }
                });
            });

            // Close button clicked
            $('.' + token.SubscribeId + '-close').click(function(event) {
                if (onClose)
                {
                    onClose();
                }
            });

            // Buy Tokens button clicked
            $('.' + dn.token.SubscribeId + '-buy-tokens').unbind('click').click(function(event) {

                var numTokens = parseFloat($(id).data('subscription-cost'));

                dn.token.Buy(
                    (numTokens - dn.token.Wallet.Balance), 
                    function(transaction) {
                        dn.token.UpdateWalletBalance($('.dn-wallet-balance'), $('.dn-wallet-balance-withdrawable'), $(id + '-error'), updateSubscribeInfo);
                        $(id).modal('show'); // our Subscribe dialog might be hidden
                    }, 
                    function() {
                        // closed without buying tokens, just update the balance anyway
                        dn.token.UpdateWalletBalance($('.dn-wallet-balance'), $('.dn-wallet-balance-withdrawable'), $(id + '-error'), updateSubscribeInfo);
                    }
                );
            });

            token.UpdateWalletBalance($('.dn-wallet-balance'), $('.dn-wallet-balance-withdrawable'), $(id + '-error'), updateSubscribeInfo);

            $(id).modal('show');
        });
    };

    /**
     * Retrieve the user's wallet.
     * 
     * @param (func) opt.onSuccess  - Callback function we'll pass the wallet info to.
     * @param (func) opt.onFailure  - (Optional) callback function we'll pass any failure info to.
     */
    token.GetWallet = function(opt) {
        $.ajax('/api/v1/wallet').done(function(wallet) {
            token.Wallet = wallet;
            opt.onSuccess(wallet);
        }).fail(function(xhr, textStatus, errorThrown) {
            if (opt.onFailure)
            {
                opt.onFailure(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * This retrieves the current user's wallet balance, and renders it
     * into the jQuery element(s) given. If showSpinner is true, we'll put
     * a spinner in the element(s) that gets replaced by the new balance
     * once it's retrieved. If there's a failure retrieving the wallet, the
     * spinner stops spinning, and can be clicked to try to retrieve again.
     * 
     * If onSuccess callback is provided, we'll pass the wallet to that function.
     * 
     * @param {element} opt.$element    - The jQuery element(s) we want to put the wallet balance in.
     * @param {bool} opt.showSpinner    - If true, show a spinner while the balance is being updated.
     * @param {func} opt.onSuccess      - (Optional) callback function we'll pass the wallet info to.
     * @param {func} opt.onFailure      - (Optional) callback function we'll pass any failure info to.
     */
    token.ShowWalletBalance = function(opt) {

        if (opt.showSpinner)
        {
            opt.$element.html('<i class="far fa-sync-alt clickable ml-2"></i>');
            if (opt.$elementWithdrawable)
            {
                opt.$elementWithdrawable.html('<i class="far fa-sync-alt clickable ml-2"></i>');
            }
        }

        token.GetWallet({

            onSuccess: function(wallet) {

                opt.$element.html(dn.constants.TokenCurrencySymbolHtml + wallet.BalanceDisplay);
                if (opt.$elementWithdrawable)
                {
                    opt.$elementWithdrawable.html(dn.constants.TokenCurrencySymbolHtml + wallet.BalanceDisplayWithdrawable);
                }

                if (opt.onSuccess)
                {
                    opt.onSuccess(wallet);
                }
            }, 

            onFailure: function(xhr, textStatus, errorThrown) {

                if (opt.showSpinner)
                {
                    // we started a spinner, so we need to clear it out
                    opt.$element.find('svg').removeClass('fa-spin');
                    opt.$element.unbind("click").click(function(e) {
                        opt.$element.find('svg').addClass('fa-spin');
                        token.ShowWalletBalance(opt);
                    });
                    if (opt.$elementWithdrawable)
                    {
                        opt.$elementWithdrawable.find('svg').removeClass('fa-spin');
                        opt.$elementWithdrawable.unbind("click").click(function(e) {
                            opt.$elementWithdrawable.find('svg').addClass('fa-spin');
                            token.ShowWalletBalance(opt);
                        });
                    }
                }
                if (opt.onFailure)
                {
                    opt.onFailure(xhr, textStatus, errorThrown);
                }
            }
        });
    };

    /**
     * Update the wallet balance in the given element, and if it fails, 
     * try to write the error in the .text() of the second given element
     */
    token.UpdateWalletBalance = function($element, $elementWithdrawable, $errorElement, onSuccess) 
    {
        dn.token.ShowWalletBalance({
            $element:   $element, 
            $elementWithdrawable:   $elementWithdrawable, 
            $spinner:   $element.find('svg.fa-sync-alt'), 
            onSuccess: function() {
                if (onSuccess)
                {
                    onSuccess();
                }
            }, 
            onFailure: function(xhr, textStatus, errorThrown) {
                if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) {
                    // The initial request for the message details failed, tell the user
                    var error = dn.FormatApiError(xhr.responseJSON);
                    $errorElement.text('Problem retrieving your wallet balance: ' + error).show();
                }
            }
        });
    };

}(window.dn.token = window.dn.token || {}, jQuery));
